import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Index from "./pages/Index.tsx";

// Lazy-load sub-routes to reduce initial JS bundle size (only Index is eager for fast LCP)
const IdeaIncubator = lazy(() => import("./pages/IdeaIncubator.tsx"));
const SaveVetsSafePets = lazy(() => import("./pages/SaveVetsSafePets.tsx"));
const VoiceAgent = lazy(() => import("./pages/VoiceAgent.tsx"));
const CallIntelligence = lazy(() => import("./pages/CallIntelligence.tsx"));
const MedicalScribe = lazy(() => import("./pages/MedicalScribe.tsx"));
const XRayIntelligence = lazy(() => import("./pages/XRayIntelligence.tsx"));
const KnowledgeCore = lazy(() => import("./pages/KnowledgeCore.tsx"));
const ChiefAuditor = lazy(() => import("./pages/ChiefAuditor.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const Auth = lazy(() => import("./pages/Auth.tsx"));
const ThankYou = lazy(() => import("./pages/ThankYou.tsx"));
const ReputationShield = lazy(() => import("./pages/ReputationShield.tsx"));
const Support = lazy(() => import("./pages/Support.tsx"));
const Invest = lazy(() => import("./pages/Invest.tsx"));
const Evidence = lazy(() => import("./pages/Evidence.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/idea-incubator" element={<IdeaIncubator />} />
              <Route path="/savevets-safepets" element={<SaveVetsSafePets />} />
              <Route path="/voice-agent" element={<VoiceAgent />} />
              <Route path="/call-intelligence" element={<CallIntelligence />} />
              <Route path="/medical-scribe" element={<MedicalScribe />} />
              <Route path="/x-ray-intelligence" element={<XRayIntelligence />} />
              <Route path="/knowledge-core" element={<KnowledgeCore />} />
              <Route path="/chief-auditor" element={<ChiefAuditor />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/reputation-shield" element={<ReputationShield />} />
              <Route path="/support" element={<Support />} />
              <Route path="/invest" element={<Invest />} />
              <Route path="/evidence" element={<Evidence />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
